export default "__VITE_ASSET__Cb8z3r9q__"